// extracted by mini-css-extract-plugin
export default {"Spinner":"index_Spinner__3KjGU","brand":"index_brand__3pfFc"};